import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DOCUMENT } from '@app/constants/Api.constant';
import { ApiService } from '@app/secure/service/Api.service';
import { CyBaseResponse } from '@app/secure/service/caseMotion.types';
import { CombineDocumentsRequest } from
    '@app/secure/interface/CombineDocumentsRequest.interface';
import { CombineDocumentsCyData } from
    '@app/secure/interface/DocumentServiceResponses.interface';

export interface DocumentDownloadRequest 
{
    id: string | number;
}

@Injectable({
    providedIn: 'root'
})

class DocumentService 
{
    private refreshDocumentList = new Subject<void>();

    refreshDocumentList$ = this.refreshDocumentList.asObservable();

    constructor
    (
        private apiService: ApiService
    )
    {}

    triggerRefreshDocumentList() 
    {
        this.refreshDocumentList.next();
    }

    /**
     * @desc   - download a document blob by file id
     * @access - public
     * @param  - DocumentDownloadRequest oneDocument : document object
     * @return - Observable serviceObj : document blob response
     */
    getDocumentContent
    (
        oneDocument: DocumentDownloadRequest
    ) : Observable<Blob>
    {
        let postData;
        let serviceObj;

        postData =
        {
            fileId: oneDocument.id
        };
        serviceObj = this.apiService.customPostArrayBlob(
            DOCUMENT.DOWNLOAD_FILE,
            postData
        );

        return serviceObj;
    }

    /**
     * @desc   - combine selected documents into one PDF
     * @access - public
     * @param  - CombineDocumentsRequest postData : combine request payload
     * @return - Observable serviceObj : combine API response
     */
    combineDocuments
    (
        postData: CombineDocumentsRequest
    ) : Observable<CyBaseResponse<CombineDocumentsCyData>>
    {
        let serviceObj;

        serviceObj = this.apiService.postRaw<
            CyBaseResponse<CombineDocumentsCyData>>(
            DOCUMENT.COMBINE_DOCUMENTS,
            postData
        );

        return serviceObj;
    }
} 

export { DocumentService };